import { BrandEnum, ProductTypeEnum, RegWorkflowEnum } from './../../../core/dtos/enum';
import { HttpErrorResponse } from '@angular/common/http';
import { OnDestroy, ViewChild } from '@angular/core';
/* eslint-disable eqeqeq */
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HotToastService } from '@ngneat/hot-toast';
import { select, Store } from '@ngrx/store';
import { forkJoin, Observable, Subscription } from 'rxjs';
import { concatMap, first } from 'rxjs/operators';
import { AddressFormData } from 'src/app/core/dtos/address-form-data';
import { CheckOutReviewInfoDto, CountryDto, PersonalLookupInfoForTestRegistrationDto, ShippingInfo, ShippingRequest, ShoppingCartDto, ShoppingCartItemDto, TestSessionForRegistrationDto, UserAccountAddressDto, UserOrderAddressRequest, UserAddressDto, PaymentProcessingRequest, PaymentMethodDto } from 'src/app/core/dtos/dto';

import { Step } from 'src/app/core/dtos/step';
import { TestPurposeOption } from 'src/app/core/dtos/test-purpose-option';
import { AccountService } from 'src/app/core/services/account.service';
import { CountryRegionService } from 'src/app/core/services/country-region.service';
import { ConfigHelper } from 'src/app/core/services/helpers/config.helper';
import { DateTimeHelper } from 'src/app/core/services/helpers/date-time.helper';
import { RegWorkflowMappingService } from 'src/app/core/services/reg-workflow-mapping.service';
import { RegistrationService } from 'src/app/core/services/registration.service';
import { ShoppingCartService } from 'src/app/core/services/shopping-cart.service';
import { StepProgressService, PageStepEnum } from 'src/app/core/services/step-progress.service';
import { selectRegTestSession, selectTestPurposeOption } from 'src/app/state/reg-data.selectors';
import { loadShoppingCart } from 'src/app/state/shopping-cart.actions';
import { selectShoppingCart } from 'src/app/state/shopping-cart.selectors';
import { CheckoutService, CheckoutWorkflowEnum } from 'src/app/core/services/checkout.service';
import { LoadingService } from 'src/app/core/services/loading.service';
import { HttpErrorResponseMessages } from 'src/app/core/dtos/http-error-response-messages';
import { NavigationRoute } from 'src/app/core/constants/constants';
import { AddressFormComponent } from 'src/app/shared/components/address-form/address-form.component';

@Component({
  selector: 'app-order-summary',
  templateUrl: './order-summary.component.html',
  styleUrls: ['./order-summary.component.scss']
})
export class OrderSummaryComponent implements OnInit, OnDestroy {

  pagePath = NavigationRoute.REGISTRATION.orderSummary;
  regWorkFlow: RegWorkflowEnum;
  wordPressUrl: string;
  steps: Step[];

  testSessionInformation$: Observable<TestSessionForRegistrationDto>;
  testPurposeOption$: Observable<TestPurposeOption>;

  testSessionInformationSubscription: Subscription;
  testPurposeOptionSubscription: Subscription;
  personalLookupSubscription: Subscription;
  shoppingCartSubscription: Subscription;

  testSessionInformation: TestSessionForRegistrationDto;
  testPurposeOption: TestPurposeOption;
  personalLookupInfo: PersonalLookupInfoForTestRegistrationDto;

  @ViewChild("shippingAddress") shippingAddressChild: AddressFormComponent;
  @ViewChild("billingAddress") billingAddressChild: AddressFormComponent;

  //Reg Info Formated
  testDate: Date;
  testTypeCssClass: string;
  testCentreCountry: string;
  testCost: number;

  //Shipping/Billing Info
  userAddress: UserAccountAddressDto;
  countries: CountryDto[];

  billingAddressFormData: AddressFormData;
  shippingAddressFormData: AddressFormData;
  isBillingFormValid = false;
  isShippingFormValid = false;
  submitted = false;
  addressSaved = false;

  shippingInfos: ShippingInfo[];
  shippingSelected: number;
  unableToShip = false;

  //Shopping Cart
  shoppingCart$: Observable<ShoppingCartDto>;
  shoppingCartDto: ShoppingCartDto;
  shoppingCartItemsOnline: ShoppingCartItemDto[];
  shoppingCartItemsPaperback: ShoppingCartItemDto[];
  shoppingCartItemsMisc: ShoppingCartItemDto[];

  //Discount Code
  discountCodeToggle = true;
  discountCode: string;

  //Checkout Page Info
  CheckOutReviewInfoDto: CheckOutReviewInfoDto;

  //Payment
  regPoliciesUrl: string;
  paymentMethods: PaymentMethodDto[];
  selectedPaymentMethodId: number;
  selectedPaymentMethodName: string;
  paymentProcessingRequest: PaymentProcessingRequest;
  currentStep = 3;
  paymentMethodInvoiceId = 14;
  browserRequirementsUrl: string;
  paymentInfo: string;

  //Enums for products
  onlineProductEnums = [ProductTypeEnum.ElectronicProductEBook, ProductTypeEnum.ElectronicProductOnline, ProductTypeEnum.OnlineProgram, ProductTypeEnum.ElectronicProductFile];
  physicalProductsEnums = [ProductTypeEnum.PhysicalProduct];
  ignoredProductEnums = [ProductTypeEnum.TestRegistration, ProductTypeEnum.ShippingAndHandling];

  //Brand info
  brandId: BrandEnum;
  phoneNumber: string;
  localTimeZone: string;

  constructor(
    private regWorkflowMappingService: RegWorkflowMappingService,
    private router: Router,
    private stepProgressServiceService: StepProgressService,
    private toastService: HotToastService,
    private registrationService: RegistrationService,
    private configHelper: ConfigHelper,
    private store: Store,
    private dateTimeHelper: DateTimeHelper,
    private accountService: AccountService,
    private countryService: CountryRegionService,
    private shoppingCartService: ShoppingCartService,
    private checkoutService: CheckoutService,
    private loadingService: LoadingService
  ) {
    this.steps = this.stepProgressServiceService.getSteps(PageStepEnum.OrderSummary);
  }

  ngOnInit() {
    this.getAddress();
    this.brandId = this.configHelper.getBrandId();
    this.phoneNumber = this.brandId === BrandEnum.CELPIP ? "1-800-958-5186" : "1-855-520-2235";
    this.localTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    this.wordPressUrl = this.configHelper.getWordPressUrl();
    this.regPoliciesUrl = this.configHelper.getRegPoliciesUrl();
    this.browserRequirementsUrl = (this.brandId === BrandEnum.CELPIP) ? "https://www.celpip.ca/faqs/" : "https://www.cael.ca/faqs/";

    this.testPurposeOption$ = this.store.pipe(select(selectTestPurposeOption));
    this.testPurposeOptionSubscription = this.testPurposeOption$
      .subscribe(testPurposeOption => {
        this.testPurposeOption = testPurposeOption;
        this.renderDependentValues();
      });

    this.testSessionInformation$ = this.store.pipe(select(selectRegTestSession));
    this.testSessionInformationSubscription = this.testSessionInformation$
      .subscribe(testSessionInformation => {
        this.testSessionInformation = testSessionInformation;
        if (testSessionInformation) {
          const testDateUtcToLocal = this.dateTimeHelper.convertUTCDateToLocalDate(new Date(testSessionInformation.testDateTimeUtc));
          this.testDate = testSessionInformation.isWebDelivery ? testDateUtcToLocal : testSessionInformation.testDateTimeTestCentre;
          this.testTypeCssClass = this.configHelper.getTestTypeCssClass(this.testSessionInformation.testTypeId);
          this.renderDependentValues();
          this.regWorkFlow = this.regWorkflowMappingService.getRegWorkFlow(testSessionInformation);

          this.personalLookupSubscription = this.registrationService.getRegPersonalLookupInfo(this.testSessionInformation.testCentreCountryId, this.testPurposeOption?.testPurposeId, this.testSessionInformation.testTypeId, this.testSessionInformation.testCentreId)
            .subscribe(
              value => {
                this.personalLookupInfo = value.content;
                this.renderDependentValues();
              },
              () => this.toastService.warning("Unable to retrieve Proof of Identity Registration options.")
            );
        }
      });

    this.shoppingCart$ = this.store.pipe(select(selectShoppingCart));
    this.shoppingCartSubscription = this.shoppingCart$.subscribe(shoppingCart => {
      this.shoppingCartDto = shoppingCart;
      this.renderShoppingCart(shoppingCart);
    });

    this.updateShoppingCart();
  }

  public get BrandEnum() {
    return BrandEnum;
  }

  ngOnDestroy() {
    this.testSessionInformationSubscription?.unsubscribe();
    this.testPurposeOptionSubscription?.unsubscribe();
    this.personalLookupSubscription?.unsubscribe();
    this.shoppingCartSubscription?.unsubscribe();
  }

  redirectNextStep() {
    const nextStep = this.regWorkflowMappingService.getNextStepNew(this.regWorkFlow, this.pagePath);
    this.router.navigate([nextStep]);
  }

  redirectTestSelection() {
    if (this.testSessionInformation.isWebDelivery) {
      this.router.navigate(['/registration/sitting-selection-web-delivery']);
    } else {
      this.router.navigate(['/registration/sitting-selection']);
    }
  }

  renderDependentValues() {
    if (this.testSessionInformation && this.personalLookupInfo) {
      //equality compare does not work between the number type id with ===
      this.testCentreCountry = this.personalLookupInfo.countries.find(x => x.id == this.testSessionInformation.testCentreCountryId)?.name;
    }
  }

  //Mirrors edit-address component

  billingFormValueChanged(formData: AddressFormData) {
    this.billingAddressFormData = formData;
    this.userAddress.billingAddress = formData.address;
  }

  shippingFormValueChanged(formData: AddressFormData) {
    this.shippingAddressFormData = formData;
    this.userAddress.shippingAddress = formData.address;
  }

  getAddress() {
    forkJoin([this.accountService.getAddress(), this.countryService.getCountries()])
      .subscribe(
        result => {
          this.userAddress = result[0].content;
          this.userAddress.areShippingBillingAddressSame = false;
          this.countries = result[1].content;
          this.countries = this.countries.filter(x => x.name !== "IRAN (ISLAMIC REPUBLIC OF)");
          //if it's null then it's a brand new account with no shipping address set
          if (this.userAddress.shippingAddress.addressLine1 != null) {
            this.updateShippingAddress(this.userAddress.areShippingBillingAddressSame, this.userAddress.billingAddress, this.userAddress.shippingAddress);
          }
        },
        (error: HttpErrorResponse) => {
          if (error.status !== 401) {
            this.toastService.warning("Unable to load address.");
          }
        });
  }

  //Mirrors shopping-cart component
  removeFromCart(id: number) {
    this.shoppingCartService.removeShoppingCartItem(id)
      .pipe(first()).subscribe(
        result => {
          this.renderShoppingCart(result.content);
          this.store.dispatch(loadShoppingCart({ shoppingCart: result.content }));
        },
        (error: HttpErrorResponse) => {
          if (error.status !== 401) {
            const errorMessage = error.error as HttpErrorResponseMessages;
            if (errorMessage?.reasons) {
              errorMessage.reasons.forEach(reasons => {
                this.toastService.warning(reasons.errorMessage);
              });
            }
            else {
              this.toastService.warning("Unable to remove item from shopping cart");
            }
          }
        }
      );
  }

  //update shoppingCart
  updateShoppingCart() {
    this.shoppingCartService.getShoppingCart().pipe(first())
      .subscribe(
        result => {
          this.renderShoppingCart(result.content);
          this.store.dispatch(loadShoppingCart({ shoppingCart: result.content }));
        },
        (error: HttpErrorResponse) => {
          if (error.status !== 401) {
            this.toastService.warning("Unable to load shopping cart");
          }
        });
  }

  renderShoppingCart(shoppingCartDto: ShoppingCartDto) {
    //check for Reg, then redirect as needed
    if (shoppingCartDto.shoppingCartItems.some(e => e.productTypeId === ProductTypeEnum.TestRegistration)) {
      this.checkoutService.setLastCheckoutFlow(CheckoutWorkflowEnum.RegCheckOut);
    } else {
      this.checkoutService.setLastCheckoutFlow(CheckoutWorkflowEnum.NoRegCheckout);
    }
    this.checkoutService.redirectCheckoutBasedOnFlow(CheckoutWorkflowEnum.RegCheckOut);

    this.shoppingCartDto = shoppingCartDto;
    this.testCost = shoppingCartDto.shoppingCartItems.filter(i => i.productTypeId === 1)[0]?.price;
    const shoppingCartItems = shoppingCartDto.shoppingCartItems.map(item => ({
      ...item,
      imageUrl: this.configHelper.getProductImageUrl(item.imageUrl)
    }));

    this.shoppingCartItemsOnline = [];
    this.shoppingCartItemsPaperback = [];
    this.shoppingCartItemsMisc = [];
    shoppingCartItems.forEach(cartItem => {
      if (this.onlineProductEnums.includes(cartItem.productTypeId)) {
        this.shoppingCartItemsOnline.push(cartItem);
      } else if (this.physicalProductsEnums.includes(cartItem.productTypeId)) {
        this.shoppingCartItemsPaperback.push(cartItem);
      } else if (this.ignoredProductEnums.includes(cartItem.productTypeId)) {
      } else {
        this.shoppingCartItemsMisc.push(cartItem);
      }
    });
  }

  //discount code
  toggleDiscountCode() {
    this.discountCodeToggle = !this.discountCodeToggle;
  }

  applyDiscountCode() {
    this.loadingService.show();
    this.checkoutService.applyDiscountCode(this.discountCode).pipe(first())
      .subscribe(
        () => {
          this.applyCheckoutFinal();
          this.loadingService.hide();
        },
        (error: HttpErrorResponse) => {
          this.loadingService.hide();
          if (error.status === 400) {
            const errorMessage = error.error as HttpErrorResponseMessages;
            errorMessage.reasons.forEach(reasons => {
              this.toastService.warning(reasons.errorMessage);
            });
          }
          else {
            this.toastService.warning("Failed to place the order because of unknown problem. Please contact Paragon.");
          }
        }
      );
  }

  //Shipping Selection
  applyShippingChoice() {
    const request: ShippingRequest = { shippingMethodId: this.shippingSelected };
    this.shoppingCartService.checkoutInfoShippingPut(request).pipe(first()).subscribe(
      () => this.applyCheckoutFinal()
    );
  }

  applyCheckoutFinal() {
    this.shoppingCartService.checkoutInfoFinal().pipe(first()).subscribe(
      checkoutFinalResult => {
        this.CheckOutReviewInfoDto = checkoutFinalResult.content;
        this.paymentInfo = this.CheckOutReviewInfoDto.paymentInfo;
        if (this.CheckOutReviewInfoDto.additionalPaymentMethods) {
          this.paymentMethods = this.CheckOutReviewInfoDto.additionalPaymentMethods;
          if (this.paymentMethods.length === 1) {
            this.selectedPaymentMethodId = this.paymentMethods[0].id;
            this.selectedPaymentMethodName = this.paymentMethods[0].name;
          }
        }
        this.updateShoppingCart();
      },
      (error: HttpErrorResponse) => {
        if (error.status !== 401) {
          const errorMessage = error.error as HttpErrorResponseMessages;
          if (errorMessage?.reasons) {
            errorMessage.reasons.forEach(reasons => {
              this.toastService.warning(reasons.errorMessage);
            });
          }
          else {
            this.toastService.warning("Unable to process your request");
          }
        }
      }
    );
  }
  checkShippingBillingErrors(): boolean {
    if (this.shippingAddressChild) {
      this.submitted = true;
      const shipAddressControls = this.shippingAddressChild.formGroup.controls;
      const billingAddressControls = this.billingAddressChild ? this.billingAddressChild.formGroup.controls : null;
      let errorMessage = "Please enter and save a Shipping Address - Missing ";
      if (shipAddressControls.fullName.errors?.required) {
        errorMessage += " Name,";
      }
      if (shipAddressControls.addressLine1.errors?.required) {
        errorMessage += " Address,";
      }
      if (shipAddressControls.city.errors?.required) {
        errorMessage += " City,";
      }
      if (shipAddressControls.regionAbbrOrName.errors?.required) {
        errorMessage += " Region,";
      }
      if (shipAddressControls.postalCode.errors?.required) {
        errorMessage += " Postal Code,";
      }
      if (shipAddressControls.phoneNumber.errors?.pattern) {
        errorMessage += " Phone number that contains only numbers and no spaces, dashes or brackets,";
      }
      if (shipAddressControls.phoneNumber.errors?.minlength) {
        errorMessage += " Phone number with a minimum of 5 digits,";
      }
      if (shipAddressControls.phoneNumber.errors?.required) {
        errorMessage += " Phone number,";
      }
      let billingErrorMessage = "Please enter and save a Billing Address - Missing ";
      if (!this.userAddress.areShippingBillingAddressSame) {
        if (billingAddressControls.fullName.errors?.required) {
          errorMessage += " Name,";
        }
        if (billingAddressControls.addressLine1.errors?.required) {
          billingErrorMessage += " Address,";
        }
        if (billingAddressControls.city.errors?.required) {
          billingErrorMessage += " City,";
        }
        if (billingAddressControls.regionAbbrOrName.errors?.required) {
          billingErrorMessage += " Region,";
        }
        if (billingAddressControls.postalCode.errors?.required) {
          billingErrorMessage += " Postal Code,";
        }
        if (billingAddressControls.phoneNumber.errors?.pattern) {
          billingErrorMessage += " Phone number that contains only numbers and no spaces, dashes or brackets,";
        }
        if (billingAddressControls.phoneNumber.errors?.minlength) {
          billingErrorMessage += " Phone number with a minimum of 5 digits,";
        }
        if (billingAddressControls.phoneNumber.errors?.required) {
          billingErrorMessage += " Phone number,";
        }
      }
      errorMessage = errorMessage.replace(/,$/, ".");
      billingErrorMessage = billingErrorMessage.replace(/,$/, ".");
      if (this.shippingAddressChild.formGroup.invalid) {
        this.toastService.warning(errorMessage);
      }
      if (!this.userAddress.areShippingBillingAddressSame && this.billingAddressChild.formGroup.invalid) {
        this.toastService.warning(billingErrorMessage);
      }
      if (this.shippingAddressChild.formGroup.invalid || (!this.userAddress.areShippingBillingAddressSame && this.billingAddressChild.formGroup.invalid)) {
        this.addressSaved = false;
        return true;
      }
      return false;
    }
  }
  //update Shipping Address
  updateShippingAddress(sameAddress: boolean, billingAddress: UserAddressDto, shippingAddress: UserAddressDto) {
    if (this.checkShippingBillingErrors()) {
      return;
    }
    const userOrderAddressRequest: UserOrderAddressRequest =
    {
      areShippingBillingAddressSame: sameAddress,
      billingAddress: sameAddress ? shippingAddress : billingAddress,
      needShippingAddress: !sameAddress,
      shippingAddress
    };
    this.shoppingCartService.checkoutInfoOrderAddress(userOrderAddressRequest).pipe(
      concatMap(() => this.shoppingCartService.prepareForShipping()),
      concatMap(() => this.shoppingCartService.checkoutInfoShippingGet())
    ).pipe(first()).subscribe(
      result => {
        this.addressSaved = true;
        if (this.submitted) {
          this.toastService.success("Saved.");
        }
        if (result.content) {
          this.shippingInfos = result.content.shippingInfos;
          if (this.shippingInfos && this.shippingInfos.length > 0) {
            this.shippingSelected = result.content.shippingInfos[0].shippingMethodId;
            this.applyShippingChoice();
            this.unableToShip = false;
          } else {
            if (result.content.isShippingNeeded) {
              this.unableToShip = true;
            } else {
              this.unableToShip = false;
            }
          }
        }
      }, (error: HttpErrorResponse) => {
        this.addressSaved = false;
        if (error.status === 400) {
          const errorMessage = error.error as HttpErrorResponseMessages;
          errorMessage.reasons.forEach(reasons => {
            this.toastService.warning(reasons.errorMessage);
          });
        }
      }).add(() => {
        this.submitted = true;
      });
  }

  //Payment methods
  selectPaymentMethod(paymentMethod: PaymentMethodDto) {
    this.selectedPaymentMethodId = paymentMethod.id;
    this.selectedPaymentMethodName = paymentMethod.name;
  }

  placeOrder() {
    if (this.checkShippingBillingErrors()) {
      return;
    }
    if (!this.addressSaved) {
      this.toastService.warning("Please save your Billing and Shipping Address.");
      return;
    }
    this.checkoutService.resetAffiliateTracking();
    if ((!this.selectedPaymentMethodId || this.selectedPaymentMethodId === 1) && this.shoppingCartDto.total > 0) {
      this.onlinePaymentCheckout();
    } else {
      this.otherPaymentMethodCheckout();
    }
  }


  otherPaymentMethodCheckout() {
    this.loadingService.show();
    this.checkoutService.placeOrder(this.selectedPaymentMethodId).pipe(first())
      .subscribe(
        (result) => {
          this.loadingService.hide();
          this.checkoutService.setLastCheckoutOrderNumber(result.content.orderNumber, CheckoutWorkflowEnum.RegCheckOut);
          this.redirectNextStep();
        },
        (error: HttpErrorResponse) => {
          this.loadingService.hide();
          if (error.status === 400) {
            const errorMessage = error.error as HttpErrorResponseMessages;
            errorMessage.reasons.forEach(reasons => {
              this.toastService.warning(reasons.errorMessage);
            });
          }
          else {
            this.toastService.warning("Failed to place the order because of unknown problem. Please contact Paragon.");
          }
        }
      );
  }

  onlinePaymentCheckout() {
    this.loadingService.show();
    this.checkoutService.placeOrder(null).pipe(first())
      .subscribe(
        (result) => {
          this.loadingService.hide();
          this.checkoutService.setLastCheckoutOrderNumber(result.content.orderNumber, CheckoutWorkflowEnum.RegCheckOut);
          this.paymentProcessingRequest = result.content;
          if (this.paymentProcessingRequest.paymentGatewayLink === null || this.paymentProcessingRequest.paymentGatewayLink.paymentGatewayId === 1) {
            this.paymentExactSubmit(this.paymentProcessingRequest);
          }
          else if (this.paymentProcessingRequest.paymentGatewayLink.paymentGatewayId === 2) {
            this.paymentPaypalSubmit(this.paymentProcessingRequest);
          }
          else if (this.paymentProcessingRequest.paymentGatewayLink.paymentGatewayId === 3) {
            this.paymentCCAvenueSubmit(this.paymentProcessingRequest);
          }
          else if (this.paymentProcessingRequest.paymentGatewayLink.paymentGatewayId === 4) {
            this.paymentRiverPaySubmit(this.paymentProcessingRequest);
          }
          else if (this.paymentProcessingRequest.paymentGatewayLink.paymentGatewayId === 5) {
            this.paymentAlphaPaySubmit(this.paymentProcessingRequest);
          }
          else if (this.paymentProcessingRequest.paymentGatewayLink.paymentGatewayId === 6) {
            this.paymentPaymentechSubmit(this.paymentProcessingRequest);
          }
          else if (this.paymentProcessingRequest.paymentGatewayLink.paymentGatewayId === 7) {
            this.paymentStripePOSubmit(this.paymentProcessingRequest);
          }
          else {
            this.toastService.warning("Failed to place the order because of unknown problem. Please contact Paragon.");
          }
        },
        (error: HttpErrorResponse) => {
          this.loadingService.hide();
          if (error.status === 400) {
            const errorMessage = error.error as HttpErrorResponseMessages;
            errorMessage.reasons.forEach(reasons => {
              this.toastService.warning(reasons.errorMessage);
            });
          }
          else {
            this.toastService.warning("Failed to place the order because of unknown problem. Please contact Paragon.");
          }
        }
      );
  }

  paymentExactSubmit(content: PaymentProcessingRequest) {
    (document.getElementById('exactForm') as HTMLFormElement).setAttribute("action", content.exactUrl);
    (document.getElementById('x_login') as HTMLInputElement).value = content.x_login;
    (document.getElementById('x_fp_sequence') as HTMLInputElement).value = content.x_fp_sequence;
    (document.getElementById('x_fp_timestamp') as HTMLInputElement).value = content.x_fp_timestamp;
    (document.getElementById('x_amount') as HTMLInputElement).value = content.x_amount;
    (document.getElementById('x_fp_hash') as HTMLInputElement).value = content.x_fp_hash;
    (document.getElementById('x_show_form') as HTMLInputElement).value = content.x_show_form;
    (document.getElementById('x_currency_code') as HTMLInputElement).value = content.x_currency_code;
    (document.getElementById('x_first_name') as HTMLInputElement).value = content.x_first_name;
    (document.getElementById('x_last_name') as HTMLInputElement).value = content.x_last_name;
    (document.getElementById('x_email') as HTMLInputElement).value = content.x_email;
    (document.getElementById('x_invoice_num') as HTMLInputElement).value = content.x_invoice_num;
    (document.getElementById('x_reference_3') as HTMLInputElement).value = content.x_reference_3;
    (document.getElementById('userAccountId') as HTMLInputElement).value = content.userAccountId.toString();
    (document.getElementById('orderNumber') as HTMLInputElement).value = content.orderNumber;
    (document.getElementById('exactForm') as HTMLFormElement).submit();
  }

  paymentPaypalSubmit(content: PaymentProcessingRequest) {
    const paypalUrl = content.paymentGatewayLink.keyValues['approval_url'];
    window.location.href = paypalUrl;
  }

  paymentStripePOSubmit(content: PaymentProcessingRequest) {
    const paymentOrchestratorUrl = content.paymentGatewayLink.keyValues['paymentOrchestratorUrl'];
    window.location.href = paymentOrchestratorUrl;
  }

  paymentCCAvenueSubmit(content: PaymentProcessingRequest) {
    (document.getElementById('ccavenueForm') as HTMLFormElement).setAttribute('action', content.paymentGatewayLink.keyValues['payment_url']);
    (document.getElementById('encRequest') as HTMLInputElement).value = content.paymentGatewayLink.keyValues['encRequest'];
    (document.getElementById('access_code') as HTMLInputElement).value = content.paymentGatewayLink?.keyValues['access_code'];
    (document.getElementById('ccavenueForm') as HTMLFormElement).submit();
  }

  paymentRiverPaySubmit(content: PaymentProcessingRequest) {
    const riverPayPayFormUrl = content.paymentGatewayLink.keyValues['pay_form_url'];
    window.location.href = riverPayPayFormUrl;
  }

  paymentAlphaPaySubmit(content: PaymentProcessingRequest) {
    const alphaPayUrl = content.paymentGatewayLink.keyValues['alpha_pay_url'];
    window.location.href = alphaPayUrl;
  }

  paymentPaymentechSubmit(content: PaymentProcessingRequest) {
    const paymentechHPPUrl = content.paymentGatewayLink.keyValues['paymentech_hpp_url'];
    const paymentech_uid = content.paymentGatewayLink.keyValues['paymentech_uid'];
    (document.getElementById('uid') as HTMLInputElement).value = paymentech_uid;
    (document.getElementById('paymentechHPPForm') as HTMLFormElement).action = paymentechHPPUrl;
    (document.getElementById('paymentechHPPForm') as HTMLFormElement).submit();
  }
}
